import { Accordion, AccordionTab } from "primereact/accordion"
import "./support.css";
import { useOutletContext } from "react-router-dom";
import { Card } from "primereact/card";

const Faq = () => {
    const { t }: any = useOutletContext();

    const header = (text: any, index: any) => {
        return (
            <div className="flex justify-content-center align-items-center">
                <p className="m-0">{index}. {text}</p>
            </div>
        )
    }

    return (
        <div className="supportAccordion flex flex-column gap-3">
            <Card style={{ borderRadius: "24px", position: "relative" }}>
                <div className="flex justify-content-center align-items-center gap-2">
                    <p className="text-3xl m-0" style={{ color: "#2D3967" }}>
                        {t("frequentlyAskedQuestions")
                            .split(" ")
                            .map((word: any, i: any) => (
                                <span key={i} className="mr-1">
                                    <span className="font-bold">{word.charAt(0)}</span>
                                    {word.slice(1)}
                                </span>
                            ))}
                    </p>
                </div>
            </Card>
            <Accordion multiple >
                <AccordionTab header={header(t("faqs.0.header"), 1)}>
                    <div className="flex justify-content-center align-items-center">
                        <p className="m-0">
                            {t("faqs.0.body")}
                        </p>
                    </div>

                </AccordionTab>
                <AccordionTab header={header(t("faqs.1.header"), 2)}>
                <div className="flex justify-content-center align-items-center">
                        <p className="m-0">
                            {t("faqs.1.body")}
                        </p>
                    </div>
                </AccordionTab>
                <AccordionTab header={header(t("faqs.2.header"), 3)}>
                <div className="flex justify-content-center align-items-center">
                        <p className="m-0">
                            {t("faqs.2.body")}
                        </p>
                    </div>
                </AccordionTab>
                <AccordionTab header={header(t("faqs.3.header"), 4)}>
                <div className="flex justify-content-center align-items-center">
                        <p className="m-0">
                            {t("faqs.3.body")}
                        </p>
                    </div>
                </AccordionTab>
                <AccordionTab header={header(t("faqs.4.header"), 5)}>
                <div className="flex justify-content-center align-items-center">
                        <p className="m-0">
                            {t("faqs.4.body")}
                        </p>
                    </div>
                </AccordionTab>
                <AccordionTab header={header(t("faqs.5.header"), 6)}>
                <div className="flex justify-content-center align-items-center">
                        <p className="m-0">
                            {t("faqs.5.body")}
                        </p>
                    </div>
                </AccordionTab>
                <AccordionTab header={header(t("faqs.6.header"), 7)}>
                <div className="flex justify-content-center align-items-center">
                        <p className="m-0">
                            {t("faqs.6.body")}
                        </p>
                    </div>
                </AccordionTab>
                <AccordionTab header={header(t("faqs.7.header"), 8)}>
                <div className="flex justify-content-center align-items-center">
                        <p className="m-0">
                            {t("faqs.7.body")}
                        </p>
                    </div>
                </AccordionTab>
            </Accordion>
        </div>
    )
}

export default Faq